// JoditEditor.js
import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import {JoditEditor} from 'jodit-react';
import axios from 'axios';

const JoditEditorComponent = forwardRef(({initValue, onChange, ref}) => {
    const editorRef = useRef()

    // useImperativeHandle(ref, () => ({
    //     getContent: () => {
    //         return editorRef.current.value;
    //     },
    // }));

    const config = {
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', 'fontsize',
            'color', 'background', 'unorderedList', 'orderedList', 'outdent', 'indent',
            'align', 'undo', 'redo', 'clear', 'link', 'image', 'source', 'video', 'table'
        ],
        uploader: {
            insertImageAsBase64URI: false,
            url: 'YOUR_IMAGE_UPLOAD_ENDPOINT',
            format: (response) => {
                if (response?.url) {
                    return response.url;
                }
                return response;
            },
            defaultHandler: {
                default: (file, done) => {
                    const formData = new FormData();
                    formData.append('image', file);

                    axios.post('YOUR_IMAGE_UPLOAD_ENDPOINT_HERE', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                        .then(response => {
                            if (response.data.url) {
                                done(response.data.url);
                            } else {
                                done(false);
                            }
                        })
                        .catch((error) => {
                            console.error('Error uploading image:', error);
                            done(false);
                        });
                }
            }
        }
    };

    return (
        <JoditEditor
            ref={editorRef}
            value={initValue}
            config={config}
            onChange={(newContent) => {
                onChange(newContent);
            }}
        />
    );
});

export default JoditEditorComponent;